
export { KanbanBoard } from "/vercel/path0/packages/plugins/kanban/src/components/kanban-board.tsx"